import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { NGXLogger as LoggerService } from "ngx-logger";
import { ReadMoreComponent } from "../../read-more/read-more.component";


@Component({
    selector: 'article-middel',
    standalone: true,
    imports: [
        CommonModule,
        ReadMoreComponent
    ],
    templateUrl: './article-middel.component.html',
    styleUrls: ['./../articles.scss'],
})

export class ArticleMiddelComponent {

    constructor(
    ) {
    }

}
